<div class="form-row">
  <label class="mb-1 col-sm-12" translate>Checkbox label</label>
  <div class="col-sm-12 mb-2">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.label" (ngModelChange)="onLabelChange($event)" />
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Field name</label>
  <div class="col-sm-12">
    <input type="text" name="field_name" [(ngModel)]="component.element.field_name" class="form-control form-control-sm" maxlength="100">
    <small class="text-muted" translate>Max 100 characters</small>
  </div>
</div>
<div class="form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.is_required" id="is_required" />
  <label for="is_required" class="form-check-label" translate>Set as required</label>       
</div>
